import { Rental, RentalDetail } from "../types/rental.type"
import { User } from "../types/user.type"

/**
 * Response from GET /v3/rental/lease/public/:leaseId (batamx-service lease entity).
 */
export type LeasePublicResponse = {
  leaseId: string
  leaseCode: string
  rate?: string | number
  unit?: {
    unitName?: string
    property?: { name?: string } | null
  } | null
  tenant?: User
}

function lineDescription(lease: LeasePublicResponse): string {
  const parts = [
    lease.unit?.property?.name,
    lease.unit?.unitName,
    lease.leaseCode,
  ].filter(Boolean)
  return parts.length > 0 ? parts.join(" — ") : "Rental"
}

function toNumber(rate: string | number | undefined): number {
  if (rate == null) return 0
  if (typeof rate === "number") return rate
  const n = parseFloat(rate)
  return Number.isNaN(n) ? 0 : n
}

/** Maps API lease JSON to the `Rental` view used on the invoice page. */
export function mapLeaseToRental(lease: LeasePublicResponse): Rental {
  const subtotal = toNumber(lease.rate)
  const detail: RentalDetail = {
    productName: lineDescription(lease),
    quantity: 1,
    subtotal,
  }
  return {
    rentalId: lease.leaseId,
    customer: lease.tenant,
    rentalDetails: [detail],
  }
}
